import { Particle } from "../particle";
import { colorConstant, constant, lerp, randomAngle, randomBetween } from "../interpolation";

const START_RADIUS_MIN = 3;
const START_RADIUS_MAX = 4;
const SPIN_RADIANS_MIN = 3;
const SPIN_RADIANS_MAX = 3;
const FALL_EXPONENT = 1;

export const BIG_SPRITE_RADIUS = 1.5;

export class BlackHoleSuctionParticle extends Particle {
	static readonly emitIntervalMs = 10;

	constructor(originX: number, originY: number, vanishRadius: number = 0) {
		const angle = randomAngle();
		const shade = randomBetween(0, 1);
		const startRadius = randomBetween(START_RADIUS_MIN, START_RADIUS_MAX);
		const spin = randomBetween(SPIN_RADIANS_MIN, SPIN_RADIANS_MAX);
		const fullTtl = randomBetween(500, 600);
		// The ttl is cut to the exact moment the trajectory crosses vanishRadius,
		// so no per-frame distance checks are needed.
		const vanishProgress = vanishRadius < startRadius ? Math.pow(1 - vanishRadius / startRadius, 1 / FALL_EXPONENT) : 0;

		super(originX, originY, {
			ttl: fullTtl * vanishProgress,
			size: lerp(0.35, 0.2),
			opacity: lerp(0.8, 1),
			color: colorConstant(Math.round(0x02 * shade), 0, Math.round(0x6d * shade)),
			rotation: constant(0),
			position: (elapsed) => {
				const progress = elapsed / fullTtl;
				const radialProgress = Math.pow(progress, FALL_EXPONENT);
				const radius = startRadius * (1 - radialProgress);
				const theta = angle + spin * radialProgress;
				return { x: Math.cos(theta) * radius, y: Math.sin(theta) * radius };
			},
		});
	}
}
